<hr />
<h2 class="mb-4"> Auto-Renew </h2>

<ng-container [formGroup]="form">

  <label for="confirmAutoRenew" [ngClass]="{required: form.get('confirmAutoRenew')?.enabled === true}">
    <p-checkbox label="I authorize the Short Code Registry to auto-renew the above lease(s)." [required]="form.get('confirmAutoRenew')?.enabled === true"
      formControlName='confirmAutoRenew' id="confirmAutoRenew" [binary]="true" #confirmAutoRenew></p-checkbox>
  </label>
  <div *ngIf="submitted && form.get('confirmAutoRenew')?.invalid">
    <span class="text-danger">
      Since at least one short code is opted in to Auto-Renew above, you must accept the Auto-Renew terms.
    </span>
  </div>

  <div class="ms-4 mt-2">
    I understand and agree that by checking this box, I authorize the Short Code Registry to charge my
    account for the applicable fee for renewal of this code for repeating leases, until I explicitly
    opt out of Auto-Renew for this code. I understand that if I have a default payment method on file,
    this payment method will be automatically charged the applicable fee; and that if I have no default
    payment method on file, my account is responsible to pay this fee by either credit card, ACH, check,
    or wire transfer. I also understand and agree that each renewal will be subject to the terms and
    conditions of short code Auto-Renew as described in the Registrant Sublicense Agreement to which I
    agreed upon order submission. Finally, I understand that there may be limitations regarding when
    I can opt out of Auto-Renew.
  </div>

</ng-container>